export const productDetail = {
  notFound: {
    title: 'Produit Non Trouvé',
    returnToProducts: 'Retour aux Produits',
  },
  breadcrumb: {
    products: 'Produits',
  },
  backButton: 'Retour à la Catégorie',
  partnerBadge: 'Partenaire',
  categoryBadge: 'Catégorie',
  keyFeatures: {
    title: 'Caractéristiques Principales',
  },
  actions: {
    downloadSheet: 'Télécharger la Fiche Technique',
    requestQuote: 'Demander un Devis',
  },
  specifications: {
    title: 'Spécifications Techniques',
  },
  applications: {
    title: 'Applications',
  },
  industries: {
    title: 'Industries',
  },
  benefits: {
    title: 'Pourquoi Choisir Ce Produit ?',
  },
  relatedProducts: {
    title: 'Produits Connexes',
    viewDetails: 'Voir les Détails',
  },
  cta: {
    title: 'Prêt à Mettre en Œuvre Cette Solution ?',
    subtitle: 'Nos experts techniques sont prêts à vous aider à intégrer ce produit dans vos processus industriels. Obtenez une consultation personnalisée et un support technique.',
    requestStudy: 'Demander une Étude Technique',
    contactTeam: 'Contacter Notre Équipe',
  },
};